import Admin from '@/models/Admin'
import store from '@/store'
import * as types from '@/store/mutation-types'
import isEmpty from 'lodash-es/isEmpty'
// import { PERMISSIONS } from '@/enum/permissions.enum'

export const AuthGuard = async (to, from, next) => {
	if (store.getters.profile) {
		PermissionGuard(to, from, next)
		return
	}

	if (!store.getters.hasToken) {
		next({ name: 'login' })
		return
	}

	try {
		const profile = await Admin.profile(store.getters.userId)

		if (isEmpty(profile)) {
			next({ name: 'login' })
			return
		}
		store.commit(types.SET_PROFILE, { profile })
		store.commit(types.SET_PERMISSION, profile.data.permissions)
		PermissionGuard(to, from, next)
	} catch (e) {
		store.commit(types.LOG_OUT)
		next({ name: 'login' })
		throw e
	}
}

export const PermissionGuard = (to, from, next) => {
	const listPreventPermissions = [
		'VIEW_MENU_FOLLOW_PROFILE',
		'ADD_MENU_FOLLOW_PROFILE',
		'EDIT_MENU_FOLLOW_PROFILE',
		'DELETE_MENU_FOLLOW_PROFILE',
		'ACCEPT_MENU_FOLLOW_PROFILE',
		'EXPORT_MENU_FOLLOW_PROFILE',

		'VIEW_PRE_CERTIFICATE',
		'ADD_PRE_CERTIFICATE',
		'EDIT_PRE_CERTIFICATE',
		'DELETE_PRE_CERTIFICATE',
		'ACCEPT_PRE_CERTIFICATE',
		'EXPORT_PRE_CERTIFICATE',

		// 'VIEW_CERTIFICATE_BRIEF',
		// 'ADD_CERTIFICATE_BRIEF',
		// 'EDIT_CERTIFICATE_BRIEF',
		// 'DELETE_CERTIFICATE_BRIEF',
		// 'ACCEPT_CERTIFICATE_BRIEF',
		// 'EXPORT_CERTIFICATE_BRIEF',

		'VIEW_ACCOUNTING',
		'ADD_ACCOUNTING',
		'EDIT_ACCOUNTING',
		'DELETE_ACCOUNTING',
		'ACCEPT_ACCOUNTING',
		'EXPORT_ACCOUNTING',

		'VIEW_DASHBOARD'
	]
	const profile = store.getters.profile.data.user;
	const permissions = store.getters.currentPermissions
	const permissionList = to.meta.permissions
	if (permissionList && permissions.find(permission => permissionList.includes(permission))) {
		if(profile.roles[0].name === 'ROOT_ADMIN' ){
			next()
		} else {
			if(!listPreventPermissions.includes(permissionList[0])){
				next()
			} else {
				next({ name: 'error.403' })
			}
		}
	} else {
		next({ name: 'error.403' })
	}
}
